import type { FC } from 'react';
import { Outlet } from 'react-router';
import styles from './styles.module.scss';

const BackgroundLayout: FC = () => (
	<div className={styles.layout}>
		<Outlet />
	</div>
);

export default BackgroundLayout;
